import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { PACKS_QUERY_KEY } from "../../constants";
import { PackListItem } from "../../packs.types";
import { requestGetPacks } from "./getPacks.request";
import { GetPacksRequestParams } from "./getPacks.types";

const useGetPacks = (
  params: GetPacksRequestParams,
  options?: QueryOptions<
    GetListResponse<PackListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: [PACKS_QUERY_KEY, params],
    queryFn: async () => await requestGetPacks(params),
    onError: toastServerError,
    ...options
  });

  return { packs: data?.data, meta: data?.meta, ...rest };
};

export default useGetPacks;
